<template>
   
 <!-- navbar -->
 <nav class="navbar navbar-expand-lg navbar-light" style="background-color:transparent; ">
        <a class="navbar-brand " href="/" style="color: #ffffff;">
        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->
        <img :src="'/imgs/tallyLogo4.png'" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  nav-link-header">Home</a> -->
                    <a href="/" class="nav-link home-nav-link nav-link-header">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/support">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Pricing
                        </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Faq's</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Support</a>
                </li>
            </ul>
        </div> 

        <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <div class="flex justify-between mr-4">
              <div class="flex justify-between space-x-2">
                <img :src="'/imgs/tally_header.png'" class="img-fluid " alt="" >
                  <div class="flex flex-col ml-2">
                    <div>
                      <h6 class=" text-xs font-semibold text-gray-400" >
                          hotline 24/7
                      </h6>
                    </div>
                  <div>
                    <h6 class=" text-xs text-gray-700 font-bold">
                        (+91)9263637575
                    </h6>
                  </div>
                          
                </div>
              </div>
              </div> 
            </ul>
             <button type="button" id="button" class=" md:py-1 py-1 mr-2 px-3 rounded-md  text-white" style="background-color: #07528E;">Get Free</button>     
        </div> 
  </nav>
    <!-- navbar --> 
 

<!-- banner start -->
<section>
   <div class="banner1 ">
       <div class="container">
           <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 ">
           <div class="mt-5">
              <h2 class="font-bold  mt-5">A better way to grow your creative business to<span style="color:#F5AB0F">Tally</span><span style="color:#87BBE0">Clinic?</span></h2> 
               <!-- Another variation with a button -->
              
             <h5 class="mt-5 sm:text-lg" style="color:">The easy way to send,receive,store and trade digital currencies.Enables users to publish single- or multi-author blogs. Allows content to be authored using third-party tools, such as Windows Live Writer. Blogs module</h5>
           </div>
           <!-- ... -->
           <div>
               <img :src="'/imgs/module_banner2.png'" class="img-fluid banner" alt="" >
           </div>
           </div>
          </div>
   </div>
 </section>
 <!-- banner end -->

 <!-- square css section start -->
 <section>
  <div class="container my-5">
  <div class="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-4 ">
    <div class="card">
       <div class="icon-wrapper">
         <i class="fas fa-hammer"></i>
       </div>
       <h4 class="head">Service Heading</h4>
       <p class="para text-sm">
         Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quisquam
         consequatur necessitatibus eaque.
       </p>
      </div>
  <!-- ... -->
  <div class="card">
       <div class="icon-wrapper">
         <i class="fas fa-hammer"></i>
       </div>
       <h4 class="head">Service Heading</h4>
       <p class="para text-sm">
         Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quisquam
         consequatur necessitatibus eaque.
       </p>
      </div>
        <!-- ... -->
  <div class="card">
  <div class="icon-wrapper">
    <i class="fas fa-hammer"></i>
  </div>
  <h4 class="head">Service Heading</h4>
  <p class="para text-sm">
    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quisquam
    consequatur necessitatibus eaque.
  </p>
      </div>   
</div>
</div>
 
 
    
  
</section>
 <!-- square css section end -->
 <!-- 2nd section start -->
 <div class="container my-4">
  <div class="row flex justify-content-between">
    
    <div class="col-md-5">
        <div class="py-4">
          
        <h1 class=" font-bold my-3">Our <span  style="color:#F2B736">Services</span></h1>
        <p class="text-secondary" style="line-height: 2;">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Magnam, ea atque reiciendis saepe et similique eveniet distinctio autem odit blanditiis. </p>
        <p class="text-secondary" style="line-height: 2;"> consequatur nesciunt doloribus ad sit reprehenderit, beatae error illo aut!</p>
        </div>
    </div>
    <div class="col-md-6">

      <div class="row">
        <div class="col-md-6 p-2 text-center">
          <div class="bg-light px-3 py-5">
            <img :src="'/imgs/module1.png'" class="img-fluid module_img"  alt="" >
            <div class="mt-3">
              <h5 class="mb-2" style="font-weight: 600;"><a href="#" class="stretched-link" style="color: #07528E">Service Name</a></h5>
              <p class="text-secondary">Lorem ipsum</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 p-2 text-center">
          <div class="bg-light px-3 py-5">
            <img :src="'/imgs/module2.png'" class="img-fluid module_img"  alt="" >
            <div class="mt-3">
              <h5 class="mb-2" style="font-weight: 600;"><a href="#" class="stretched-link" style="color: #07528E">Service Name</a></h5>
              <p class="text-secondary">Lorem ipsum</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 p-2 text-center">
          <div class="bg-light px-3 py-5">
            <img :src="'/imgs/module3.png'" class="img-fluid module_img" alt="" >
            <div class="mt-3">
              <h5 class="mb-2" style="font-weight: 600;"><a href="#" class="stretched-link" style="color: #07528E">Service Name</a></h5>
              <p class="text-secondary">Lorem ipsum</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 p-2 text-center">
          <div class="bg-light px-3 py-5">
            <img :src="'/imgs/module4.png'" class="img-fluid module_img" alt="" >
            <div class="mt-3">
              <h5 class="mb-2" style="font-weight: 600;"><a href="#" class="stretched-link" style="color: #07528E">Service Name</a></h5>
              <p class="text-secondary">Lorem ipsum</p>
            </div>
          </div>
        </div>
        
      </div>
      
    </div>

  </div>
</div>
 <!-- 2nd section end -->

 <!-- 3rd section start -->
 <div class="py-4 bg-white">
  <div class="text-left mb-4 container">
   <!-- <h1 class=" sm:text-4xl leading-normal font-extrabold tracking-tight text-gray-900">
     Our <span class="" style="color:#F2B736"> Features</span>
   </h1> -->
   <h1 class=" sm:text-4xl leading-normal font-extrabold  text-gray-900" >Keep your inventory in <span style="color:#F2B736">sync</span></h1>
</div>
  <div class="max-w-screen-xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 md:col-gap-8 md:row-gap-10  flex-row items-center justify-center"> 
  
    <div class="">
        <ul class="grid grid-cols-1 md:row-gap-10">
          <li class="py-3 md:mt-0">
          <div class="flex flex-col px-4 mx-5">
            <div class="flex-shrink-0">
                <img :src="'/imgs/module_icon4.png'" class="img-fluid module_img"  alt="" >
            </div>
            <div class="mt-2">
              <h4 class="text-lg  font-semibold text-gray-900">Service Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
        </li>       
        <li class="py-3 md:mt-0">
          <div class="flex flex-col px-4 mx-5">
            <div class="flex-shrink-0">
                <img :src="'/imgs/module_icon4.png'" class="img-fluid module_img"  alt="" >
            </div>
            <div class="mt-2">
              <h4 class="text-lg  font-semibold text-gray-900">Service Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
        </li>
          <li class="py-3 md:mt-0">
          <div class="flex flex-col px-4 mx-5">
            <div class="flex-shrink-0">
                <img :src="'/imgs/module_icon4.png'" class="img-fluid module_img"  alt="" >
            </div>
            <div class="mt-2">
              <h4 class="text-lg  font-semibold text-gray-900">Service Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
        </li>
        </ul>
      </div>
    
    <div class="">
      <img :src="'/imgs/module9.png'" class="img-fluid " alt="" >
    </div>

      <div class="">
        <ul class="grid grid-cols-1 md:row-gap-10">
          <li class="py-3 md:mt-0">
          <div class="flex flex-col px-4 mx-5">
            <div class="flex-shrink-0">
                <img :src="'/imgs/module_icon4.png'" class="img-fluid module_img"  alt="" >
            </div>
            <div class="mt-2">
              <h4 class="text-lg  font-semibold text-gray-900">Service Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
        </li>        
        <li class="py-3 md:mt-0">
          <div class="flex flex-col px-4 mx-5">
            <div class="flex-shrink-0">
                <img :src="'/imgs/module_icon4.png'" class="img-fluid module_img"  alt="" >
            </div>
            <div class="mt-2">
              <h4 class="text-lg  font-semibold text-gray-900">Service Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
        </li>
          <li class="py-3 md:mt-0">
          <div class="flex flex-col px-4 mx-5">
            <div class="flex-shrink-0">
                <img :src="'/imgs/module_icon4.png'" class="img-fluid module_img"  alt="" >
            </div>
            <div class="mt-2">
              <h4 class="text-lg  font-semibold text-gray-900">Service Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
        </li>
        </ul>
      </div>
    
  </div>
</div>
 <!-- 3rd section end -->

  <!-- 4th section start -->
  <div class="py-4 gry_sec">
   <div class="container">
    <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4">
      <div>
        <img :src="'/imgs/module7.png'" class="img-fluid "  alt="" >
      </div>
      <!-- ... -->
      <div>
        <h1 class=" font-bold my-3">Featured <span  style="color:#F2B736">Products</span></h1>
        <!-- <h3 class="mt-5 font-bold">Featured <span class="color:#f2b736"> Products</span></h3> -->
        <p class="mt-5">Lorem ipsum dolor sit amet consectetur adipisicing elit. Error voluptatum libero maiores cum optio autem officiis inventore nobis repudiandae sit dolorem iste, tenetur, numquam ipsam obcaecati et laboriosam magnam debitis! Maiores, consequuntur?</p>
        
        <button class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 mt-5 rounded-full">
         See More
        </button>
      </div>
    </div>
   </div>
  </div>
  <!-- 4th section end -->

   <!-- footer start -->
 <div>
        <footer class="section bg-footer section-main-container">
          <div class="container">
              <div class="row">
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Get our app</h6>
  
                          <div class="">
                              <a href=""><img
                                      src="/imgs/gp.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                              <a href=""> <img
                                      src="/imgs/gp2.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Resources</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-2">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Help</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-4">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Contact Us</h6>
                          <table>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-envelope contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; abc@aruvaa.com</p>
                                  </td>
                              </tr>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-mobile-alt contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; +01 123-456-7890</p>
                                  </td>
                              </tr>
                          </table>
  
   </div>
                  </div>
  
              </div>
          </div>
  
          <div class="text-center mt-5 container">
              <hr class="footer-hr">
              <div class="d-flex justify-content-center below-hr-container">
                  <a href=""><span>Privary Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Terms of use</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Cookie Privacy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Abuse Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Anti-spam Policy</span></a>
              </div>
              <p class="footer-alt mb-0 f-14 mt-2">2019 © Aruvaa, All Rights Reserved</p>
          </div>
      </footer>
    </div>
    <!-- footer end -->
</template>

<script>
export default {
mounted(){
   

}
}
</script>

<style>
* {
  outline: none;
}
h6{
margin-bottom: 0.1rem;
}
.img_size{
 height: auto;
 width: 156px;
}
.module_img{
    height: auto;
 width: 40px;   
}
.navbar {
  position: relative;
  display: flex;
  align-items: center; 
  padding: .5rem 5rem;
}
.nav-link-header {
     color: #9c761f !important;
     font-weight: 650 !important;
     font-size: 16px;
 }
 /* banner */
.banner1{
    background: #E5EFE7;
background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
}
.gry_sec{
  background: #E5EFE7;
background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
}
/* circle section css start */
.card {
  width: 100%;
  height: 100%;
  padding: 1.5em 1.5em;
  background: linear-gradient(#ffffff 50%, #F2B736 50%);
  background-size: 100% 200%;
  background-position: 0 2.5%;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  cursor: pointer;
  transition: 0.5s;
}
.head {
  color: #1f194c;
  margin: 0.7em 0;
}
.para {
  color: black;
  letter-spacing: 0.03em;
}
.icon-wrapper {
  background-color: #F2B736;
  position: relative;
  margin: auto;
  font-size: 25px;
  height: 2.3em;
  width: 2.3em;
  color: #ffffff;
  border-radius: 50%;
  display: grid;
  place-items: center;
  transition: 0.5s;
}
.card:hover {
  background-position: 0 100%;
}
.card:hover .icon-wrapper {
  background-color: #ffffff;
  color: #F2B736;
}
/* circle section end */

/* footer css start */
.bg-footer {
          background-color: #33383c;
          padding: 50px 0 30px;
      }
      .footer-heading {
          letter-spacing: 2px;
      }
      .footer-link a {
          color: #ffffff;
          font-size: 14px;
          transition: all 0.2s;
          text-decoration: none;
      }
      .footer-link a:hover {
          color: #FDC031;
          text-decoration: none;
      }
      .contact-info {
          color: #ffffff;
          font-size: 14px;
      }
      .footer-alt {
          color: #818282;
          font-size: 12px;
      }
      .footer-heading {
          position: relative;
          padding-bottom: -12px !important;
      }
      .footer-heading:after {
          content: '';
          width: 25px;
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
      }
      .contact-info-icon {
          color: #ffffff;
          font-size: 16px;
      }
      .contact-info-data {
          color: #ffffff;
          font-size: 16px;
          margin: 0px 0px 0px !important;
      }
      /* Extra small devices (phones, 600px and down) */
      @media  only screen and (max-width: 600px) {
          .footer-download-icon {
              width: 36%;
          }
      }
      /* Small devices (portrait tablets and large phones, 600px and up) */
      @media  only screen and (min-width: 600px) {
          .footer-download-icon {
              width: 36%;
          }
          .carousel-content {
   
    transition: width .4s;
    height: 80%;
  }
      }
      @media  only screen and (max-width: 758px) {
        .sec_rectangle{
        display: none;
    }  
    .dp-view{
      display: none;
    }
    .navbar {
  padding: .5rem 1rem;
}
      }
      @media only screen and (max-width: 992px) {
    .navbar {
  padding: .5rem 1rem;
}
  }
      /* Medium devices (landscape tablets, 768px and up) */
      @media  only screen and (min-width: 768px) {
          .footer-download-icon {
              width: 40%;
          }
          .carousel-content {
    transition: width .4s;
    height: 80%;
  }
          
      }
      /* Large devices (laptops/desktops, 992px and up) */
      @media  only screen and (min-width: 992px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
    transition: width .4s;
    height: 60%;
  }
      }
      /* Extra large devices (large laptops and desktops, 1200px and up) */
      @media  only screen and (min-width: 1200px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
    transition: width .4s;
    height: 60%;
  }
      }
      .footer-get-trial-button {
          background: #FDC031;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 6px;
          padding-bottom: 6px;
          font-weight: bold;
          border-radius: 4px;
          border: none;
          color: #333;
          text-align: center;
          margin-top: 10px;
          font-weight: 500;
          transition: all 0.5s;
          cursor: pointer;
      }
      .footer-hr {
          border-color: #404447;
          background-color: #404447;
          color: #404447;
      }
      .below-hr-container {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a:hover {
          text-decoration: none;
      }
  /* footer css end */
</style>
